var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.66658C9 10.1268 9.3731 10.4999 9.83333 10.4999C10.2936 10.4999 10.6667 10.1268 10.6667 9.66658C10.6667 9.20635 10.2936 8.83325 9.83333 8.83325C9.3731 8.83325 9 9.20635 9 9.66658Z",
    stroke: "#374151",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8333 9.66658C14.8333 10.1268 15.2064 10.4999 15.6667 10.4999C16.1269 10.4999 16.5 10.1268 16.5 9.66658C16.5 9.20635 16.1269 8.83325 15.6667 8.83325C15.2064 8.83325 14.8333 9.20635 14.8333 9.66658Z",
    stroke: "#374151",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16667 9.66658C3.16667 10.1268 3.53976 10.4999 4 10.4999C4.46024 10.4999 4.83333 10.1268 4.83333 9.66658C4.83333 9.20635 4.46024 8.83325 4 8.83325C3.53976 8.83325 3.16667 9.20635 3.16667 9.66658Z",
    stroke: "#374151",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.95c3a45ebe8dba673ad606763bfbb517.svg";
export { ForwardRef as ReactComponent };